exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-table[data-v-04eda40e] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-04eda40e] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n[data-v-04eda40e] .el-tabs__content {\n  height: 100% !important;\n}\n.con-left[data-v-04eda40e] {\n  background: none !important;\n  flex: 1 1 auto;\n  min-width: 1;\n}\n.con-right[data-v-04eda40e] {\n  width: 170px;\n  flex: 0 0 170px;\n}\n.stoptip[data-v-04eda40e] {\n  width: 100% !important;\n  height: 100% !important;\n}\n.video-box[data-v-04eda40e] {\n  width: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04eda40e","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/simulate/newQianNiu.vue
// module id = 1389
// module chunks = 0